import { Checkbox, FormControlLabel, Grid } from '@material-ui/core'
import { SelectFilter } from './SelectFilter'

export const EmailFiltersPanel = ({
  copros,
  loading,
  value,
  setValue,
  selectAll,
  handleSelectAllChange,
  selectAllCS,
  handleSelectAllCS,
}) => {
  return (
    <Grid container justifyContent="flex-start" alignItems="center">
      <Grid item xs={12} sm={4}>
        <SelectFilter
          id="autocomplete-copros"
          options={copros}
          loading={loading}
          loadingText="Chargement en cours..."
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue)
          }}
          getOptionLabel={(option) => option.code}
          label="Copropriété"
        />
      </Grid>
      <Grid item xs={8}>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={selectAll}
              onChange={handleSelectAllChange}
            />
          }
          label="Tous les contacts"
          disabled={!value}
        />
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={selectAllCS}
              onChange={handleSelectAllCS}
            />
          }
          label="Tous les conseillers syndicaux"
          disabled={!value}
        />
      </Grid>
    </Grid>
  )
}
